import { Loader as MapsLoader } from '@googlemaps/js-api-loader';
import AnalyticsHelper from '../../utils/analytics-helper.js';

export default class DealerSearch {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.batd-search-location-wrapper');
        this.form = this.el.querySelector('form');
        this.input = this.el.querySelector('.batd-search-input');
        this.submit = this.el.querySelector('.batd-search-submit');
        this.filters = this.el.querySelector('.batd-search-filters');
        this.location = this.el.querySelector('.batd-search-location');
        this.background = parent.background;
        this.preferredDealer = parent.preferredDealer;
        this.loader = parent.loader;
        this.results = parent.results;
        this.previous = {};
        this.autocomplete();
        this.currentLocation();
        this.bind();
    }

    autocomplete() {
        if (this.input.dataset.autocomplete) {
            const mapsLoader = new MapsLoader({ apiKey: this.input.dataset.mapapikey, version: 'weekly', libraries: ['places'] });
            mapsLoader.load().then(() => {
                new google.maps.places.Autocomplete(this.input, { types: ['geocode', 'establishment'], componentRestrictions: { country: this.input.dataset.mapregion } });
            });
        }
    }

    currentLocation() {
        if (navigator.geolocation && location.protocol == 'https:') {
            this.location.addEventListener('click', (e) => {
                e.preventDefault();
                navigator.geolocation.getCurrentPosition((pos) => {
                    const lat = pos.coords.latitude;
                    const lng = pos.coords.longitude;
                    const value = `${lat} ${lng}`;

                    if (value !== this.router.params.get('query')) {
                        this.router.params.set('query', value);
                        this.router.update();
                    }
                });
            });
        } else {
            this.location.classList.add('hide');
        }
    }

    bind() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            const { value } = this.input;
            if (value !== this.router.params.get('query')) {
                this.router.params.set('query', value);
                this.router.update();
            }
        });
    }

    show() {
        this.toggle();
        this.populate();
        this.search();
    }

    populate() {
        const query = this.router.params.get('query');
        this.input.value = query;
    }

    search() {
        const current = { query: this.router.params.get('query'), filters: [this.router.params.get('filter'), this.router.params.get('filter2')].filter((f) => f).join(',') };
        if (!this.valid() || !current.query) {
            this.results.hide();
            this.background.show();
            this.preferredDealer.show();
        } else if (_.isEqual(current, this.previous)) {
            this.results.show();
            this.background.hide();
            this.preferredDealer.hide();
        } else {
            this.results.hide();
            this.background.hide();
            this.preferredDealer.hide();
            this.loader.show();

            this.previous = current;
            this.filters.value = current.filters;
            fetch(this.form.action, { method: 'POST', body: new FormData(this.form) })
                .then((response) => response.json())
                .then((results) => this.results.render(current.query, results))
                .catch((error) => this.results.render(current.query));

            AnalyticsHelper.template(this.form, {
                model: this.router.params.get(this.router.data.param),
                query: this.router.params.get('query'),
            });
            AnalyticsHelper.push(this.form);
        }
    }

    valid() {
        return this.router.params.has(this.router.data.param);
    }

    toggle() {
        if (this.valid()) {
            this.el.classList.remove('disabled');
            this.input.disabled = false;
            this.submit.disabled = false;
        } else {
            this.el.classList.add('disabled');
            this.input.disabled = true;
            this.submit.disabled = true;
        }
    }
}
